import angular from 'angular';
import 'angular-ui-router';
import 'angular-ui-mask';
import 'angular-ui-bootstrap';
import 'angular-touch';
import 'angular-animate';
import 'angular-messages';
import 'ng-file-upload';
import 'cropper';

import {routes} from './app/routing.js';
import {strings} from '@nuskin/ns-common-account';

var accountModule = angular.module('nuskin-mec-account', ['ui.router', 'ui.mask', 'ui.bootstrap', 'ngTouch', 'ngAnimate', 'ngMessages', 'ngFileUpload']);

accountModule.config(function($stateProvider, $locationProvider) {
    // Fixed the Angular forcing exclamation mark issue
    // http://stackoverflow.com/questions/38455077/angular-force-an-undesired-exclamation-mark-in-url/41223197#41223197
    // https://docs.angularjs.org/guide/$location#html5-mode
    $locationProvider.hashPrefix('');

    for (let i = 0, len = routes.list.length; i < len; i++) {
        $stateProvider.state(routes.list[i]);
    }
});

accountModule.run(['$state', '$stateParams', '$rootScope', ($state, $stateParams, $rootScope) => {
    $rootScope.strings = strings;
    $rootScope.state = $state;
    $rootScope.configs = {};
    $rootScope.model = {};
    $rootScope.sharedValues = {};

    $rootScope.$on('$stateChangeSuccess', function(event, toState) {
        if (toState) {
            console.log('Route changed:', toState.url);
            if (typeof _satellite !== 'undefined') {
                _satellite.track('account:' + toState.url);
            }
        }
    });

    // TODO: May want to investigate a more sophisticated solution
    // for going back to where the user wanted to go
    var destination = window.location.hash;
    if (destination) {
        var replacement = (destination.indexOf('#!') >= 0) ? '#!/' : '#/';
        destination = destination.replace(replacement, '');
        $state.go(destination);
    } else {
        $state.go('personal');
    }

    $rootScope.currentViewName = function() {
        return $rootScope.strings.get('routes', $state.current.name);
    };
}]);

export default accountModule;



//////////////////
// WEBPACK FOOTER
// ./app.js
// module id = 9
// module chunks = 0